import { useTranslation } from "react-i18next";
const useTimeZoneList = () => {
  const { t } = useTranslation();
  const timeZoneData = [
    {
      value: "-12:00",
      name: t("zoontime.International"),
    },
    {
      value: "-11:00",
      name: t("zoontime.Coordinated"),
    },
    {
      value: "-10:00",
      name: t("zoontime.Hawaii"),
    },
    {
      value: "-09:00",
      name: t("zoontime.Alaska"),
    },
    {
      value: "-08:00",
      name: t("zoontime.California"),
    },
    {
      value: "-07:00",
      name: t("zoontime.Arizona"),
    },
    {
      value: "-06:00",
      name: t("zoontime.America"),
    },
    {
      value: "-05:00",
      name: t("zoontime.Eastern"),
    },
    {
      value: "-04:30",
      name: t("zoontime.Caracas"),
    },
    {
      value: "-04:00",
      name: t("zoontime.Atlantic"),
    },
    {
      value: "-03:30",
      name: t("zoontime.Newfoundland"),
    },
    {
      value: "-03:00",
      name: t("zoontime.Brasilia"),
    },
    {
      value: "-02:00",
      name: t("zoontime.International2"),
    },
    {
      value: "-01:00",
      name: t("zoontime.Azores"),
    },
    {
      value: "00:00",
      name: t("zoontime.Edinburgh"),
    },
    {
      value: "+01:00",
      name: t("zoontime.Brussels"),
    },
    {
      value: "+02:00",
      name: t("zoontime.Damascus"),
    },
    {
      value: "+03:00",
      name: t("zoontime.Kuwait"),
    },
    {
      value: "+03:30",
      name: t("zoontime.Tehran"),
    },
    {
      value: "+04:00",
      name: t("zoontime.Yerevan"),
    },
    {
      value: "+04:30",
      name: t("zoontime.Kabul"),
    },
    {
      value: "+05:00",
      name: t("zoontime.Karachi"),
    },
    {
      value: "+05:30",
      name: t("zoontime.Calcutta"),
    },
    {
      value: "+05:45",
      name: t("zoontime.Kathmandu"),
    },
    {
      value: "+06:00",
      name: t("zoontime.Novosibirsk"),
    },
    {
      value: "+06:30",
      name: t("zoontime.Yangon"),
    },
    {
      value: "+07:00",
      name: t("zoontime.Jakarta"),
    },
    {
      value: "+08:00",
      name: t("zoontime.Beijing"),
    },
    {
      value: "+09:00",
      name: t("zoontime.Yakutsk"),
    },
    {
      value: "+09:30",
      name: t("zoontime.Adelaide"),
    },
    {
      value: "+10:00",
      name: t("zoontime.Canberra"),
    },
    {
      value: "+11:00",
      name: t("zoontime.Islands"),
    },
    {
      value: "+12:00",
      name: t("zoontime.Oakland"),
    },
    {
      value: "+13:00",
      name: t("zoontime.alofa"),
    },
    {
      value: "+14:00",
      name: t("zoontime.Island"),
    },
  ];

  return timeZoneData;
};

// const timeZoneList = timeZoneData();

export default useTimeZoneList;

const timeZoneMapping = {
  "Etc/GMT-12": "(GMT-12:00) International Date Line West",
  "Pacific/Pago_Pago": "(UTC-11)Coordinated Universal Time-11",
  "Pacific/Honolulu": "(UTC-10)Hawaii",
  "America/Anchorage": "(UTC-9)Alaska",
  "America/Los_Angeles": "(UTC-8)Pacific Time (US & Canada), Baja California",
  "America/Denver": "(UTC-7)La Paz, Mountain Time (US & Canada), Arizona",
  "America/Chicago":
    "(UTC-6)Saskatchewan, Central Time (US & Canada), Central America",
  "America/New_York":
    "(UTC-5)Bogota, Lima, Quito, Rio Branco, Eastern Time (US & Canada), Indiana (East)",
  "America/Caracas": "(UTC-4:30)Caracas",
  "America/Halifax":
    "(UTC-4)Atlantic Time (Canada), Cuiaba, Georgetown, La Paz, Santiago",
  "America/St_Johns": "(UTC-3:30)Newfoundland",
  "America/Sao_Paulo": "(UTC-3)Brasilia, Buenos Aires, Greenland, Cayenne",
  "America/Argentina/Buenos_Aires": "(UTC-3:00) Buenos Aires",
  "Africa/Lagos": "(UTC+1)Lagos, Algiers, Casablanca",
  "Africa/Cairo": "(UTC+2)Cairo, Johannesburg, Harare",
  "Africa/Nairobi": "(UTC+3)Nairobi, Baghdad, Kuwait, Moscow, St. Petersburg",
  "Africa/Algiers": "(UTC+1:00) West Central Africa",
  "Africa/Johannesburg": "(UTC+2)Cairo, Johannesburg, Harare",
  "Etc/GMT-2": "(UTC-2)International Date Line West-02",
  "Atlantic/Azores": "(UTC-1)Cape Verde Islands, Azores",
  "Europe/London": "(UTC)Dublin, Edinburgh, Lisbon, London",
  "Europe/Paris": "(UTC+1)Amsterdam, Brussels, Sarajevo",
  "Europe/Athens":
    "(UTC+2)Beirut, Damascus, Eastern Europe, Cairo, Athens, Jerusalem",
  "Europe/Moscow": "(UTC+3)Baghdad, Kuwait, Moscow, St. Petersburg, Nairobi",
  "Asia/Tehran": "(UTC+3:30)Tehran",
  "Asia/Dubai": "(UTC+4)Abu Dhabi, Yerevan, Baku, Port Louis, Samarra",
  "Asia/Kabul": "(UTC+4:30)Kabul",
  "Asia/Karachi": "(UTC+5)Ashgabat, Islamabad, Karachi",
  "Asia/Kolkata": "(UTC+5:30)Chennai, Kolkata, Mumbai, New Delhi",
  "Asia/Kathmandu": "(UTC+5:45)Kathmandu",
  "Asia/Dhaka": "(UTC+6)Astana, Dhaka, Novosibirsk",
  "Asia/Yangon": "(UTC+6:30)Yangon",
  "Asia/Bangkok": "(UTC+7)Bangkok, Hanoi, Jakarta",
  "Asia/Shanghai":
    "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi, Kuala Lumpur, Singapore",
  "Asia/Tokyo": "(UTC+9)Osaka, Tokyo, Seoul, Yakutsk",
  "Australia/Adelaide": "(UTC+9:30)Adelaide, Darwin",
  "Australia/Sydney": "(UTC+10)Brisbane, Vladivostok, Guam, Canberra",
  "Pacific/Guadalcanal": "(UTC+11)Solomon Islands, New Caledonia",
  "Pacific/Auckland": "(UTC+12)Anadyr, Oakland, Wellington, Fiji",
  "Pacific/Tongatapu": "(UTC+13)Nuku'alofa, Samoa Islands",
  "Pacific/Kiritimati": "(UTC+14)Christmas Island",
};

export { timeZoneMapping };
